<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active' : appRejectInfoModal}" id="app-reject-info-template">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <div class="title">반려 사유</div>
      </div>
      <div class="modal-body-container">
        <div class="table-wrap no-line-mg">
          <table class="table-body-only">
            <caption>반려사유 표</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">공고명</th>
                <td>{{ title }}</td>
              </tr>
              <tr>
                <th scope="row">반려 사유</th>
                <td>
                  {{ rejectInfo }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150  close-modal" @click="close">
          닫기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-reject-info-template',
  props: ['appRejectInfoModal', 'title', 'rejectInfo'],
  components: {},
  data() {
    return {
      annNm: '',
      rejectInfo: '',
    };
  },
  watch: {},
  methods: {
    close() {
      this.$emit('update:appRejectInfo', false);
    },
  },
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// AppRejectInfo.vue?35e7f214